define('RecipesAndEvents.Facets.ItemListSortSelector.View', [
    'Facets.ItemListSortSelector.View',
    'SC.Configuration',
    'Utils',
    'Backbone',
    'underscore'
], function RecipesAndEventsFacetsItemListSortSelectorView(
    FacetsItemListSortSelectorView,
    Configuration,
    Utils,
    Backbone,
    _
) {
    'use strict';

    _.extend(FacetsItemListSortSelectorView.prototype, {
        getContext: _.wrap(FacetsItemListSortSelectorView.prototype.getContext, function getContext(fn) {
            var orignalContext = fn.apply(this, _.toArray(arguments).slice(1));
            var defaultSortConfigOption = this.getDefaultSortOption();
            var defaultOption;
            if (this.isRecipe() && orignalContext && orignalContext.options && orignalContext.options.length && defaultSortConfigOption) {
                defaultOption = _.findWhere(orignalContext.options, { name: defaultSortConfigOption.name });
                if (defaultOption) {
                    defaultOption.name = Configuration.get('recipesAndEvents.sortLabel');
                }
            }
            return orignalContext;
        }),
        isRecipe: function isRecipe() {
            var url = Backbone.history.fragment;
            return url.indexOf('custitem_item_type=Recipe') > -1 || url.indexOf('custitem_item_type/Recipe') > -1;
        },
        getDefaultSortOption: function getDefaultSortOption() {
            var screenType = Utils.getDeviceType();
            var configSort;
            var defaultSortOption;
            if (screenType === 'phone') {
                configSort = Configuration.get('sortOptionsPhone') || [];
            } else if (screenType === 'tablet') {
                configSort = Configuration.get('sortOptionsTablet') || [];
            } else {
                configSort = Configuration.get('sortOptions') || [];
            }
            if (configSort && configSort.length) {
                defaultSortOption = _.findWhere(configSort, { isDefault: true });
            }
            return defaultSortOption;
        }
    });
});
